import React from 'react'
import { Modal, Row, Col } from 'react-bootstrap'
import Button from '../Button'

const ConfirmResultModal = ({ show, onHide, confirmResult }) => {
    return (
        <Modal
            centered
            show={show}
            onHide={onHide}
            dialogClassName="create-draw-pair-modal"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    <h2>Potvrdi rezultat</h2>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <p>
                            Proverio sam i potvrđujem da je rezultat ispravno
                            unet?
                        </p>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button type="text" onClick={onHide}>
                    Odustani
                </Button>
                <Button onClick={confirmResult}>Potvrdi</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmResultModal
